import React from "react";
import { modules } from "../data/content";
import { surface } from "../data/theme";
import { getIcon } from "../utils/icons";
import { Reveal } from "./Reveal";
import { Section } from "./Section";
import { SectionTitle } from "./SectionTitle";
import { VerbChips } from "./VerbChips";
export function Modules() {
  return <Section labelledBy="modules-title" className="bg-white" waveTo={surface.mist} data-id="element-116" data-mp="20uu192if54u8">
      <Reveal data-id="element-117" data-mp="146o4t2vnhir1">
        <SectionTitle id="modules-title" title={modules.title} highlight={modules.highlight} className="text-center" data-id="element-118" data-mp="1477kecxtvv1w" />
      </Reveal>
      <ul className="mt-10 space-y-4" data-id="element-119" data-mp="189kg08iv2cky">
        {modules.items.map((item, i) => {
        const Icon = getIcon(item.icon);
        return <Reveal as="li" key={item.title} delay={i * 0.04} className="rounded-2xl border border-line bg-white p-5 shadow-[0_6px_24px_-14px_rgba(13,42,71,0.25)] transition-[transform,box-shadow] duration-200 ease-out hover:-translate-y-0.5 hover:shadow-[0_16px_36px_-16px_rgba(13,42,71,0.3)] sm:p-6" data-id="element-120" data-mp="1i5dwg2zpaq80" data-mpi={i}>
              <div className="flex items-center gap-4" data-id="element-121" data-mp="1vl2x7q5vmoa">
                <span className="bg-gold-gradient flex h-12 w-12 shrink-0 items-center justify-center rounded-full font-display text-2xl font-extrabold text-navy shadow-[0_6px_16px_-6px_rgba(217,154,43,0.7)]" data-id="element-122" data-mp="1syvd839t762">
                  {item.number}
                </span>
                <div className="min-w-0 flex-1" data-id="element-123" data-mp="3jzmpy40p2bxh">
                  <p className="text-[11px] font-bold uppercase tracking-[0.12em] text-muted" data-id="element-124" data-mp="3k327relr5z2l">
                    {item.label}
                  </p>
                  <h3 className="mt-0.5 text-base font-extrabold uppercase leading-snug text-navy sm:text-[17px]" data-id="element-125" data-mp="3a9tlro2vsz39">
                    {item.title}
                  </h3>
                </div>
                <span className="hidden h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-navy/[0.05] text-navy sm:flex" data-id="element-126" data-mp="31b9c1cfatzr6">
                  <Icon className="h-5 w-5" aria-hidden="true" data-id="element-127" data-mp="2wabsowijyzo3" />
                </span>
              </div>
              <p className="mt-4 flex gap-3 leading-relaxed text-navy/80" data-id="element-128" data-mp="2re3jdzr1e0ou">
                <Icon className="mt-1 h-4 w-4 shrink-0 text-gold-ink sm:hidden" aria-hidden="true" data-id="element-129" data-mp="2hmtmtut97z03" />
                <span data-id="element-130" data-mp="2mp2jb15c5j6y">{item.text}</span>
              </p>
              <VerbChips text={item.punchline} className="mt-4" data-id="element-131" data-mp="28o886aqwl44l" />
            </Reveal>;
      })}
      </ul>
    </Section>;
}